import React from 'react';

const storeComp = {}

export const returnComponent = (module, url, props) => {

    const key = module + "_"+url;
    if (!storeComp[key]) {
        storeComp[key]= React.lazy(() => import(`app/${module}/${url}`)) ;
    
    }
    const OtherComponent =storeComp[key];

    return <OtherComponent {...props} />
}
